'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(RoutablePage2) {
  RoutablePage2[RoutablePage2["HOME"] = 0] = "HOME";
  RoutablePage2[RoutablePage2["SIGN_UP"] = 1] = "SIGN_UP";
  RoutablePage2[RoutablePage2["SIGN_UP_BANKID"] = 2] = "SIGN_UP_BANKID";
  RoutablePage2[RoutablePage2["SIGN_UP_DONE"] = 3] = "SIGN_UP_DONE";
  RoutablePage2[RoutablePage2["PASS_RESET_REQUEST"] = 4] = "PASS_RESET_REQUEST";
  RoutablePage2[RoutablePage2["PASS_RESET_CONFIRMATION"] = 5] = "PASS_RESET_CONFIRMATION";
  RoutablePage2[RoutablePage2["PASS_RESET_CONFIRMATION_DONE"] = 6] = "PASS_RESET_CONFIRMATION_DONE";
  RoutablePage2[RoutablePage2["PASS_RESET_SUCCESS"] = 7] = "PASS_RESET_SUCCESS";
  RoutablePage2[RoutablePage2["LOG_IN"] = 8] = "LOG_IN";
  RoutablePage2[RoutablePage2["LOG_IN_DONE"] = 9] = "LOG_IN_DONE";
  RoutablePage2[RoutablePage2["GAMEPLAY"] = 10] = "GAMEPLAY";
  RoutablePage2[RoutablePage2["GAMEPLAY_DONE"] = 11] = "GAMEPLAY_DONE";
  RoutablePage2[RoutablePage2["ACCOUNT"] = 12] = "ACCOUNT";
  RoutablePage2[RoutablePage2["PROFILE"] = 13] = "PROFILE";
  RoutablePage2[RoutablePage2["CHANGE_EMAIL"] = 14] = "CHANGE_EMAIL";
  RoutablePage2[RoutablePage2["CHANGE_PASSWORD"] = 15] = "CHANGE_PASSWORD";
  RoutablePage2[RoutablePage2["CHANGE_SECURITY_QUESTION"] = 16] = "CHANGE_SECURITY_QUESTION";
  RoutablePage2[RoutablePage2["MARKETING_PREFERENCES"] = 17] = "MARKETING_PREFERENCES";
  RoutablePage2[RoutablePage2["ACCOUNT_CLOSURE"] = 18] = "ACCOUNT_CLOSURE";
  RoutablePage2[RoutablePage2["ACCOUNT_CLOSURE_FORM"] = 19] = "ACCOUNT_CLOSURE_FORM";
  RoutablePage2[RoutablePage2["ACCOUNT_CLOSURE_SUCCESS"] = 20] = "ACCOUNT_CLOSURE_SUCCESS";
  RoutablePage2[RoutablePage2["ACCOUNT_CLOSURE_ERROR"] = 21] = "ACCOUNT_CLOSURE_ERROR";
  RoutablePage2[RoutablePage2["ACCOUNT_CLOSURE_DONE"] = 22] = "ACCOUNT_CLOSURE_DONE";
  RoutablePage2[RoutablePage2["WITHDRAW"] = 23] = "WITHDRAW";
  RoutablePage2[RoutablePage2["RESPONSIBLE_GAMING"] = 24] = "RESPONSIBLE_GAMING";
  RoutablePage2[RoutablePage2["RESPONSIBLE_GAMING_PAGE"] = 25] = "RESPONSIBLE_GAMING_PAGE";
  RoutablePage2[RoutablePage2["VIEW_LIMITS"] = 26] = "VIEW_LIMITS";
  RoutablePage2[RoutablePage2["CREATE_LIMITS"] = 27] = "CREATE_LIMITS";
  RoutablePage2[RoutablePage2["SELF_EXCLUDE"] = 28] = "SELF_EXCLUDE";
  RoutablePage2[RoutablePage2["PANIC_SELF_EXCLUDE"] = 29] = "PANIC_SELF_EXCLUDE";
  RoutablePage2[RoutablePage2["TIME_OUT"] = 30] = "TIME_OUT";
  RoutablePage2[RoutablePage2["MESSAGES"] = 31] = "MESSAGES";
  RoutablePage2[RoutablePage2["MESSAGE"] = 32] = "MESSAGE";
  RoutablePage2[RoutablePage2["VERIFICATION"] = 33] = "VERIFICATION";
  RoutablePage2[RoutablePage2["SOW"] = 34] = "SOW";
  RoutablePage2[RoutablePage2["USER_INFO"] = 35] = "USER_INFO";
  RoutablePage2[RoutablePage2["NOT_FOUND"] = 36] = "NOT_FOUND";
  RoutablePage2[RoutablePage2["LIVE_CHAT"] = 37] = "LIVE_CHAT";
  RoutablePage2[RoutablePage2["WALLET_DEPOSIT"] = 38] = "WALLET_DEPOSIT";
  RoutablePage2[RoutablePage2["WALLET_HISTORY"] = 39] = "WALLET_HISTORY";
  RoutablePage2[RoutablePage2["WALLET_HISTORY_GAMING"] = 40] = "WALLET_HISTORY_GAMING";
  RoutablePage2[RoutablePage2["WALLET_BONUS"] = 41] = "WALLET_BONUS";
  RoutablePage2[RoutablePage2["WALLET_WITHDRAW"] = 42] = "WALLET_WITHDRAW";
  RoutablePage2[RoutablePage2["REWARD_DETAIL"] = 43] = "REWARD_DETAIL";
  RoutablePage2[RoutablePage2["REWARDS"] = 44] = "REWARDS";
  RoutablePage2[RoutablePage2["OFFER"] = 45] = "OFFER";
  RoutablePage2[RoutablePage2["PROMOTION"] = 46] = "PROMOTION";
  RoutablePage2[RoutablePage2["PROMOTIONS"] = 47] = "PROMOTIONS";
  RoutablePage2[RoutablePage2["GAMES"] = 48] = "GAMES";
  RoutablePage2[RoutablePage2["SEARCH"] = 49] = "SEARCH";
  RoutablePage2[RoutablePage2["FAQ"] = 50] = "FAQ";
  RoutablePage2[RoutablePage2["FAQ_CATEGORY"] = 51] = "FAQ_CATEGORY";
  RoutablePage2[RoutablePage2["REALITY_CHECK"] = 52] = "REALITY_CHECK";
  RoutablePage2[RoutablePage2["SPORTSBOOK"] = 53] = "SPORTSBOOK";
  RoutablePage2[RoutablePage2["SPORTSBOOK_INTERNAL"] = 54] = "SPORTSBOOK_INTERNAL";
  RoutablePage2[RoutablePage2["PASS_RESET_SECURITY_QUESTION"] = 55] = "PASS_RESET_SECURITY_QUESTION";
  RoutablePage2[RoutablePage2["LEADERBOARDS"] = 56] = "LEADERBOARDS";
  RoutablePage2[RoutablePage2["TOURNAMENTS"] = 57] = "TOURNAMENTS";
  RoutablePage2[RoutablePage2["TOURNAMENTS_STARTING_SOON"] = 58] = "TOURNAMENTS_STARTING_SOON";
  RoutablePage2[RoutablePage2["TOURNAMENTS_HISTORY"] = 59] = "TOURNAMENTS_HISTORY";
  RoutablePage2[RoutablePage2["PASS_RESET_EMAIL"] = 60] = "PASS_RESET_EMAIL";
  RoutablePage2[RoutablePage2["PASS_RESET_SMS"] = 61] = "PASS_RESET_SMS";
  RoutablePage2[RoutablePage2["LIVE_CASINO"] = 62] = "LIVE_CASINO";
  RoutablePage2[RoutablePage2["ACCOUNT_CUSTOM_ITEM"] = 63] = "ACCOUNT_CUSTOM_ITEM";
  RoutablePage2[RoutablePage2["TWO_FACTOR_AUTHENTICATION"] = 64] = "TWO_FACTOR_AUTHENTICATION";
  RoutablePage2[RoutablePage2["SIGN_UP_HYBRID"] = 65] = "SIGN_UP_HYBRID";
  RoutablePage2[RoutablePage2["LOTBA_OLD_SELF_EXCLUSION_LINK"] = 66] = "LOTBA_OLD_SELF_EXCLUSION_LINK";
  RoutablePage2[RoutablePage2["PLAY_CONTROL"] = 67] = "PLAY_CONTROL";
  RoutablePage2[RoutablePage2["LANDING"] = 68] = "LANDING";
  RoutablePage2[RoutablePage2["LANDING_SIGNUP"] = 69] = "LANDING_SIGNUP";
  RoutablePage2[RoutablePage2["FREE_TO_PLAY"] = 70] = "FREE_TO_PLAY";
  RoutablePage2[RoutablePage2["PROMOTION_PLAY"] = 71] = "PROMOTION_PLAY";
  RoutablePage2[RoutablePage2["SET_LIMITS"] = 72] = "SET_LIMITS";
  RoutablePage2[RoutablePage2["BINGO_LOBBY"] = 73] = "BINGO_LOBBY";
})(exports.RoutablePage || (exports.RoutablePage = {}));
